import { axiosCore } from './http-core-service';
import { PageContentExterneDto } from './dtos/page-content-externe.dto';
import { PageContentDto } from './dtos/page-content.dto';
import { PagesPaginationDto } from './dtos/pages-pagination.dto';

/**
 * Récupération du contenu d'une page grâce à son code
 * Attribut : key => string
 **/
export const getPageContent = async (key: string): Promise<PageContentExterneDto[]> => {
    const response = await axiosCore.get('/parametre_agence_en_lignes?page=1&itemsPerPage=10&codePage=' + key);
    return response.data['hydra:member'];
};

/**
 * Récupération du contenu d'une page grâce à son code
 * Attribut : key => string
 **/
export const searchPages = async (page: number, rowsPerPage: number): Promise<PagesPaginationDto> => {
    const response = await axiosCore.get(
        `/parametre_agence_en_lignes?page=${page}&itemsPerPage=${rowsPerPage}&pagination=true&administrable=true`
    );
    return {
        pages: response.data['hydra:member'],
        totalItems: response.data['hydra:totalItems'],
    };
};

export const deletePage = async (page: number): Promise<string> => {
    const response = await axiosCore.delete('/parametre_agence_en_lignes/' + page);
    return response.data?.message;
};

/**
 * Récupère le contenu d'un champ d'une page de contenu
 *
 * @param {string} id - Identifiant du champ.
 * @returns {Promise<PageContentExterneDto>} - Contenu du champ.
 */
export const getFieldContent = async (id: string | undefined): Promise<PageContentExterneDto> => {
    const response = await axiosCore.get(`/parametre_agence_en_lignes/${id}`);
    return response.data;
};

/**
 * Updates the content of a field.
 *
 * @async
 * @param id - Id of the field
 * @param {PageContentExterneDto} newFieldContent - The new content of the field.
 * @returns {Promise<any>} - The updated field content.
 */
export const updateFieldContent = async (
    id: string,
    newFieldContent: { codePage: string; codeChamps: string; valeur: string }
): Promise<any> => {
    const response = await axiosCore.patch(id, newFieldContent);
    return response.data;
};

/**
 * Transformation du contenu de la page en format PageContentDTO
 * Attribut : result => PageContentExterneDto[]
 **/
export const toPageContentDTO = async (result: PageContentExterneDto[]): Promise<PageContentDto> => {
    let data: { [key: string]: string } = {};
    result.forEach(e => {
        data[e.codeChamps?.toLowerCase()] = e.valeur;
    });

    return {
        title: data['title'],
        content: data['content'],
        image: data['image'] ?? null,
        key: data['key'] ?? null,
        permanent: data['permanent'] === 'true' ?? false,
    };
};
